import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { CollectionType } from '../../home.domain';
import { StepCount } from './StepCount';

export const Summary = ({
  next,
  back,
  version,
  submitting,
  max,
  step,
}: {
  next: () => void;
  back: () => void;
  version: CollectionType;
  submitting?: boolean;
  max: number;
  step: number;
}) => {
  const url =
    version === 'otp'
      ? 'https://www.loom.com/embed/22429f50b198494b881a6abf42173c55?sid=59b35de6-b86a-460a-9bf2-5a355af1f5f7'
      : 'https://www.loom.com/embed/331973cd17554ecb8a492a121e79e5bb?sid=b8953b6f-fadf-41ca-9f1c-4714c3bec29b';
  const title =
    version === 'otp'
      ? 'What makes a fantastic OTP?'
      : 'What makes a fantastic Subscription?';

  return (
    <div className="flex flex-col w-full h-full">
      <StepCount step={step} max={max} />
      <div className="flex flex-col items-center justify-center gap-[23px] w-full h-full">
        <Typography variant="headline" size="large" className="text-center">
          {title}
        </Typography>
        <Typography className="text-center" variant="body" size="large">
          We've got all the guidelines you need so that you know exactly how
          much content to create ahead of selling.
        </Typography>
        <iframe
          src={url}
          className="absolute; t-0 l-0 w-full h-full rounded-[20px] max-w-[60%] max-h-[400px] bg-black"
          id="offerSummaryVideo"
        ></iframe>
      </div>
      <div className="flex justify-between">
        <Button
          variant="text"
          color="neutral"
          onClick={back}
          disabled={submitting}
        >
          Back
        </Button>
        <Button
          color="neutral"
          onClick={next}
          disabled={submitting}
          loading={submitting}
        >
          Ok, let's start
        </Button>
      </div>
    </div>
  );
};
